import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { FORMULAS_OPTIONS_LABELS } from "@shared/constants/formulas-options.constants";
import { AgreementType } from "@shared/enums/agreementType";
import { FormulasOptions } from "@shared/enums/formulas-options";
import { HouseType } from "@shared/enums/houseType";
import { PackagesType } from "@shared/enums/packages-type";
import { RiskItemInformations } from "@shared/enums/riskItemInformations";
import { DividerModule } from "primeng/divider";

@Component({
  selector: "app-options-list-mrh",
  standalone: true,
  imports: [CommonModule, TranslateModule, DividerModule],
  templateUrl: "./options-list-mrh.component.html",
  styleUrl: "./options-list-mrh.component.scss",
})
export class OptionsListMrhComponent implements OnInit {
  @Input() details!: any;
  hasValuableObject = false;

  options = FormulasOptions;
  optionsLabels = FORMULAS_OPTIONS_LABELS;
  packagesType = PackagesType;
  agreementType = AgreementType;
  riskItemInfo = RiskItemInformations;
  houseType = HouseType;

  ngOnInit() {
    this.checkValuableObject();
    this.checkHouseType();
  }

  checkValuableObject() {
    this.hasValuableObject = this.details.formulasAndOptionsInformations.options.some(
      (item: any) => item.type === this.options.OBJVAL
    );
  }

  get selectedOptionsCount(): any[] {
    return this.details.formulasAndOptionsInformations.options.filter((item: any) => item.isSelected) ?? [];
  }

  get enhancements(): any[] {
    const enhancements = this.details.formulasAndOptionsInformations.enhancements ?? [];

    enhancements.forEach((item: any) => {
      if (item.code === this.options.RPM) {
        item.label = "Capitaux mobilier";
      }
    });
    return enhancements;
  }

  get RPM(): any {
    return this.enhancements.find((item: any) => item.code === this.options.RPM);
  }

  get ObjVal(): any {
    return this.enhancements.find((item: any) => item.code === this.options.OBJVAL);
  }

  checkHouseType = () =>
    this.details.riskItemInformations.values.find((item: any) => item.code === this.riskItemInfo.HAB_TYPE)!.value;

  getOptionLabel(type: FormulasOptions): string {
    return this.optionsLabels[type];
  }

  isContract() {
    return this.details.agreementType === this.agreementType.CP;
  }
}
